const TOPIC_FALLBACK_COLOR = '#6B7280';

export const getTopicColor = (_name: string, configColor?: string | null): string => {
  return configColor || TOPIC_FALLBACK_COLOR;
};
